export default __webpack_public_path__ + "static/media/textures.1fb60425.png";